import { useContext } from 'react'
import { ProjectsContext, type ProjectsContextModel } from './ProjectsContext'

const useProjects = (): ProjectsContextModel => {
  return useContext(ProjectsContext)
}

export default useProjects
